import LIVR from "livr";
import extraRules from "livr-extra-rules";

import rules from "./rules";
import { REQUIRED_ERRORS, WRONG_FORMAT_ERRORS } from "./errors";

LIVR.Validator.registerDefaultRules(extraRules);
LIVR.Validator.defaultAutoTrim(true);

function validate({ rule, data, onSuccess, onError }) {
  const validator = new LIVR.Validator(rule);
  const validData = validator.validate(data);

  if (validData) {
    if (onSuccess) onSuccess(validData);
  } else {
    const decodedErrors = decodeErrorObject(validator.getErrors());

    if (onError) {
      onError(decodedErrors);
    }
  }
}

export function validateOtherLink(args) {
  return validate({ rule: rules.otherLink, ...args });
}

export function validateNote(args) {
  return validate({ rule: rules.notes, ...args });
}

export function validateSearchCriteriaTitle(args) {
  return validate({ rule: rules.searchCriteria, ...args });
}

function decodeErrorObject(errors) {
  const decodedErrors = { ...errors };

  for (const field in decodedErrors) {
    if (decodedErrors.hasOwnProperty(field)) {
      const errorField = field.replace("data/", "");

      decodedErrors[errorField] = decodeErrorCode(
        decodedErrors[field],
        errorField
      );
    }
  }

  return decodedErrors;
}

export function decodeErrorCode(code, field = "") {
  switch (code) {
    case "REQUIRED": {
      const errorMessage = field && REQUIRED_ERRORS[field];

      return errorMessage || "Value is required";
    }

    case "WRONG_EMAIL": {
      return "A valid email is required.";
    }

    case "WRONG_URL": {
      const errorMessage = WRONG_FORMAT_ERRORS[field];

      return errorMessage || "Wrong format";
    }

    default: {
      return code;
    }
  }
}

export function placementIsActive(endDate) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const end = new Date(endDate);
  end.setHours(23, 59, 59, 0);

  return end >= today;
}
